export default __webpack_public_path__ + "static/media/IndependenceNew5.dd430a09.JPG";